import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';

try {
  const container = document.getElementById('root');
  if (!container) {
    throw new Error("Element #root tidak ditemukan di HTML.");
  }
  
  createRoot(container).render(
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>,
  );
} catch (error) {
  console.error("Critical Render Error:", error);
  const root = document.getElementById('root');
  if (root) {
    root.innerHTML = `<div style="padding: 40px; text-align: center; color: white; background: #0a0a0a; min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; font-family: sans-serif;">
      <h1 style="color: #C9A14A; font-size: 24px; font-weight: bold; margin-bottom: 8px;">Aplikasi Azman204</h1>
      <p style="opacity: 0.8; font-size: 14px; max-width: 480px; margin-bottom: 20px;">Terjadi kendala inisialisasi awal. Silakan muat ulang halaman browser.</p>
      <button onclick="window.location.reload()" style="padding: 10px 24px; background: #C9A14A; color: #0a0a0a; border: none; border-radius: 8px; font-weight: bold; cursor: pointer;">
        Muat Ulang Halaman
      </button>
    </div>`;
  }
}
